export default class Inventory {
    constructor() {
        this.inventory = {
            id: '',
            version: 0,
            hotel: {},
            roomCategoryId: '',
            roomCategoryName: '',
            selectedInventoryStatus: 0,
            inventoryData: {
                allocationByDay: []
            },
            roomType: {
                Single: 10,
                Double: 10,
                Twin: 10,
                Triple: 0,
                Quad: 0,
                Family: 0,
                Dormitory: 0,
                'Double for Single Use': 0,
                'Twin for Single Use': 0
            },
            editIndex: -1,
            readOnly: true
        };
        this.allocationRooms = [];
        this.freesaleRooms = [];
        this.allocation = {
            count: 0,
            releaseDays: 0,
            status: 3
        };
        this.freesale = {
            count: 0,
            releaseDays: 0,
            status: 3
        };
        this.allocationActive = true;
        this.freesaleActive = true;
    }
}
